/**
 * Home V2 支持展示的 Agent 类型。
 */
export type WorkInProgressAgent = 'NOVELTY_SEARCH' | 'FTO_SEARCH' | 'DESIGN_FTO_SEARCH';

/**
 * AI 任务类型，与后端 `AiTaskTypeEnum` 保持一致。
 */
export enum AiTaskType {
    /** AI 翻译任务。 */
    AI_TRANSLATION = 'AI_TRANSLATION',
    /** AI 技术交底书任务。 */
    AI_PATENT_DISCLOSURE = 'AI_PATENT_DISCLOSURE',
    /** AI 专利说明书任务。 */
    AI_SPECIFICATION = 'AI_SPECIFICATION',
    /** 旧版 AI 新颖性检索任务。 */
    AI_NOVELTY_SEARCH = 'AI_NOVELTY_SEARCH',
    /** V2 AI 新颖性检索任务。 */
    AI_NOVELTY_SEARCH_V2 = 'AI_NOVELTY_SEARCH_V2',
    /** 旧版 AI FTO 检索任务。 */
    AI_FTO_SEARCH = 'AI_FTO_SEARCH',
    /** 新版 AI FTO 检索任务。 */
    AI_NEW_FTO_SEARCH = 'AI_NEW_FTO_SEARCH',
    /** AI 外观设计检索任务。 */
    AI_IMAGE_SEARCH = 'AI_IMAGE_SEARCH',
    /** AI 审查意见答复任务。 */
    AI_OAR = 'AI_OAR',
}

/**
 * Home V2 工作中任务接口当前支持的任务类型。
 */
export type WorkInProgressTaskType =
    | AiTaskType.AI_NOVELTY_SEARCH
    | AiTaskType.AI_NOVELTY_SEARCH_V2
    | AiTaskType.AI_NEW_FTO_SEARCH
    | AiTaskType.AI_IMAGE_SEARCH;

/**
 * 工作中任务的执行状态。
 */
export type WorkInProgressTaskStatus = 'Ready' | 'Running' | 'Complete';

/**
 * Home V2 工作中任务条目。
 */
export interface WorkInProgressTask {
    /** 任务唯一标识。 */
    task_id: string;
    /** 任务标题；未生成标题时为 null。 */
    title: string | null;
    /** 任务所属 Agent。 */
    agent: WorkInProgressAgent;
    /** 后端提供的 Agent 展示名称。 */
    agent_name: string;
    /** 用于任务打开与报告导出分发的后端任务类型。 */
    task_type: WorkInProgressTaskType;
    /** 任务当前执行状态。 */
    task_status: WorkInProgressTaskStatus;
    /** 报告是否已导出。 */
    exported: boolean;
    /** 是否已开启完成邮件通知。 */
    email_notify: boolean;
    /** 任务最后更新时间戳。 */
    updated_at: number;
}

/**
 * 开启邮件通知接口的返回数据。
 */
export interface WorkInProgressEmailNotificationResult {
    /** 当前任务是否已开启邮件通知。 */
    email_notify: boolean;
}
